export { default as VRGDA } from "./VRGDA"
export { default as Custom } from "./Custom"
export { default as NFTDiscount } from "./NFTDiscount"
export { default as KeysDiscount } from "./KeysDiscount"
